module.exports = __webpack_public_path__ + "static/media/PB-DE-Kleine-Aapjes-december-2019.fe176bd4.pdf";